const MODULE_NOT_FOUND_REGEX = /Cannot find module/i;

/**
 * True when a dynamic `import()` failed because the module doesn't exist —
 * the expected outcome for a tenant that supplies no optional page. Any
 * other failure (syntax error, chunk load, a throw during evaluation) is a
 * real problem the caller should log rather than swallow.
 */
export function isModuleAbsent(err: unknown): boolean {
  if (typeof err !== "object" || err === null) return false;
  const { code, message } = err as { code?: unknown; message?: unknown };
  return (
    code === "MODULE_NOT_FOUND" ||
    (typeof message === "string" && MODULE_NOT_FOUND_REGEX.test(message))
  );
}
